import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getUserToken } from "../utilityFunctions/localServices";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";

import { GET_FUNNEL_TYPES, POST_FUNNEL_TYPES, STAGE_LINKED_TASK, STAGE_UNLINKED_TASK } from "../constants";

export const funnelApis = createApi({
  reducerPath: "funnel",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchFunnelType: builder.query({
      query: ({ is_deployed }) => {
        return {
          url: `${GET_FUNNEL_TYPES}?is_deployed=${is_deployed}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    postCreateFunnel: builder.mutation({
      query: ({ payload }) => {
        return {
          url: GET_FUNNEL_TYPES,
          method: "POST",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
          body: payload,
        };
      },
    }),

    postCreateStage: builder.mutation({
      query: ({ funnelId, payload }) => ({
        url: `${GET_FUNNEL_TYPES}/${funnelId}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),

    deleteFunnelStage: builder.mutation({
      query: ({ funnelId, stageId }) => ({
        url: `${GET_FUNNEL_TYPES}/${funnelId}/${stageId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    postDragFunnelStages: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `${POST_FUNNEL_TYPES}/stage-rank`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
          body: payload,
        };
      },
    }),

    updateFunnelState: builder.mutation({
      query: ({ funnelId, payload }) => ({
        url: `${POST_FUNNEL_TYPES}/${funnelId}/state`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),

    deleteFunnel: builder.mutation({
      query: (funnelId) => ({
        url: `${GET_FUNNEL_TYPES}/${funnelId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    LinkStageWithTask: builder.mutation({
      query: (payload) => ({
        url: `${STAGE_LINKED_TASK}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),

    fetchFunnelStages: builder.query({
      query: ({ funnel_id, task_id }) => {
        const url = task_id
          ? `${GET_FUNNEL_TYPES}/${funnel_id}?task_id=${task_id}`
          : `${GET_FUNNEL_TYPES}/${funnel_id}`;
        if (!funnel_id) {
          throw new Error("Funnel ID is required to fetch stages");
        }
        return {
          url: url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const {
  useFetchFunnelTypeQuery,
  usePostCreateFunnelMutation,
  usePostCreateStageMutation,
  useFetchFunnelStagesQuery,
  useDeleteFunnelStageMutation,
  useUpdateFunnelStateMutation, //draft//active
  useDeleteFunnelMutation,
  usePostDragFunnelStagesMutation,
  useLinkStageWithTaskMutation,
  useLazyFetchFunnelTypeQuery,
} = funnelApis;
